import React, { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';
import { LinkButtonView } from '@vivli/shared/components';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';

interface ReadOnlyText2Row2HeadersViewProps {
    textContent: string;
    textContent2?: string;
    textHeader: string;
    textHeader2?: string;
    showButton?: boolean;
    textContentStyle?: CSSProperties;
    textHeaderStyle?: CSSProperties;
}

const containerStyle: CSSProperties = {
    gridTemplateRows: '1fr 1fr',
    gridTemplateColumns: '1fr 1fr',
    backgroundColor: 'transparent',
    paddingTop: Size.PADDING,
};

const defaultTextContentStyle: CSSProperties = {
    fontSize: 20,
    fontWeight: Size.FontWeight.Regular,
    color: Color.DARK_GRAY,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};

const defaultTextHeaderStyle: CSSProperties = {
    fontSize: 15,
    paddingBottom: 1.5,
    fontWeight: Size.FontWeight.ExtraBold,
    color: Color.DARK_GRAY,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};

const linkButtonStyle: CSSProperties = {
    width: 150,
    marginLeft: -50,
};

const headerAndButtonStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    width: '40%',
    minWidth: '392px',
};

// Shows two rows of text content under two headers, with an optional link button as the first header
export const ReadOnlyText2Row2HeadersView = ({
    textContent,
    textContent2,
    textHeader,
    textHeader2,
    showButton,
    textContentStyle,
    textHeaderStyle,
}: ReadOnlyText2Row2HeadersViewProps) => {
    const [linkPressed, setLinkPressed] = React.useState(false);
    const handleClick = () => {
        setLinkPressed(true);
        alert('link button was pressed'); //placeholder, replace with real action
    };
    return (
        <div style={containerStyle}>
            <div style={headerAndButtonStyle}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        ...defaultTextHeaderStyle,
                        ...textHeaderStyle,
                    }}
                    title={textHeader}
                >
                    <span style={{ display: 'inline-block' }}>{textHeader}</span>
                    {showButton && (
                        <LinkButtonView title={textHeader2} style={linkButtonStyle} onClick={handleClick}>
                            {textHeader2}
                        </LinkButtonView>
                    )}
                </div>
            </div>
            <div style={{ ...defaultTextContentStyle, ...textContentStyle }} title={textContent}>
                <div>{textContent}</div>
                <div>{textContent2}</div>
            </div>
        </div>
    );
};
